import React, { useEffect, useRef, useState } from 'react';
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TextField, IconButton, Dialog, DialogContent, DialogTitle, Button
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';
import { useReactToPrint } from 'react-to-print';
import { CLIENT_ADDRESS_LINES, CLIENT_NAME, CLIENT_TELEPHONE } from '../config/clientInfo';

function Billhistory() {
  const ReturnprintsRef = useRef();
  const [billHeaders, setBillHeaders] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBillItems, setSelectedBillItems] = useState([]);
  const [selectedBillMeta, setSelectedBillMeta] = useState(null);
  const [viewOpen, setViewOpen] = useState(false);

  const userRole = JSON.parse(localStorage.getItem("AutoParts"))?.role;

  useEffect(() => {
    axios.get('https://serverrion.mylksystems.store/billing/getBillHeaders')
      .then(res => {
        setBillHeaders(res.data);
        setFilteredBills(res.data);
      })
      .catch(err => console.error('Error fetching bill headers:', err));
  }, []);

  useEffect(() => {
    const filtered = billHeaders.filter(bill =>
      String(bill.inv_no || '').toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredBills(filtered);
  }, [searchTerm, billHeaders]);

  const loadBill = async (inv_no) => {
    try {
      const res = await axios.post(`https://serverrion.mylksystems.store/billing/getSingleBill`, { inv_no });
      if (res.data && res.data.length > 0) {
        const meta = {
          inv_no: res.data[0].billNo,
          username: res.data[0].username,
          inv_date: res.data[0].inv_date,
          gross_total: res.data[0].gross_total,
          discount: res.data[0].discount,
          net_total: res.data[0].net_total,
          Service_chrg: res.data[0].Service_chrg,
          excessFoodTag: res.data[0].excessFoodTag,
        };
        setSelectedBillItems(res.data);
        setSelectedBillMeta(meta);
        return true;
      }
      return false;
    } catch (err) {
      console.error('Error fetching single bill:', err);
      return false;
    }
  };

  const handlePrintTrigger = useReactToPrint({
    content: () => ReturnprintsRef.current,
  });

  const handlePrint = async (inv_no) => {
    const ok = await loadBill(inv_no);
    if (ok) setTimeout(() => handlePrintTrigger(), 200);
  };

  const handleView = async (inv_no) => {
    const ok = await loadBill(inv_no);
    if (ok) setViewOpen(true);
  };

  const renderBillTable = ({ withRef }) => {
    if (!selectedBillMeta || selectedBillItems.length === 0) return null;

    return (
        <table
          border={0}
          width="300"
          style={{ fontFamily: 'Consolas', backgroundColor: 'white', fontWeight: 'bold' }}
          ref={withRef ? ReturnprintsRef : undefined}
        >
          <tbody>
             <tr>
              <td colSpan={4} align='center' style={{ fontSize: 14, fontWeight: 'bold' }}><label style={{ fontSize: 20 }}> </label><br></br> {CLIENT_NAME}<br></br>
              {CLIENT_ADDRESS_LINES[0]}<br></br>
              {CLIENT_ADDRESS_LINES[1]}<br></br>
                <img src={require('../Assests/whatsapp.png')} alt='' width={10} style={{marginRight : 10}}></img>
              Tel. {CLIENT_TELEPHONE}  <br></br>
                <img src={require('../Assests/Call.png')} alt='' width={10} style={{marginRight : 10}}></img>
              Tel. {CLIENT_TELEPHONE}  <br></br>

               </td>
              
            </tr>
            <tr><td colSpan={4}>---------------------------------</td></tr>
            <tr><td colSpan={4}>Cashier: {selectedBillMeta.username}</td></tr>
            <tr><td colSpan={4}>Date: {selectedBillMeta.inv_date}</td></tr>
            <tr><td colSpan={4}>Invoice no: {selectedBillMeta.inv_no}</td></tr>
            <tr><td colSpan={4}>---------------------------------</td></tr>

            {selectedBillItems.map((e, i) => (
              <React.Fragment key={i}>
                <tr>
                  <td colSpan={4}>{i + 1}). {e.item_name}</td>
                </tr>
                <tr>
                  <td align="right">{e.qty}</td>
                  <td align="center">{parseFloat(e.unitprice).toFixed(2)}</td>
                  <td align="right">{parseFloat(e.total).toFixed(2)}</td>
                </tr>
              </React.Fragment>
            ))}

            <tr><td colSpan={4}>---------------------------------</td></tr>
            <tr>
              <td colSpan={2} align="left">Gross Rs.</td>
              <td colSpan={2} align="right"> {selectedBillMeta.gross_total}</td>
            </tr>
            <tr>
              <td colSpan={2} align="left">Discount Rs.</td>
              <td colSpan={2} align="right"> ({selectedBillMeta.discount})</td>
            </tr>
            {Number(selectedBillMeta.Service_chrg || 0) > 0 ? (
              <tr>
                <td colSpan={2} align="Left">Service Charge (10%) Rs.</td>
                <td colSpan={2} align="right"> {selectedBillMeta.Service_chrg}</td>
              </tr>
            ) : null}
            {Number(selectedBillMeta.excessFoodTag || 0) === 1 ? (
              <tr>
                <td colSpan={4} align="center">Excess Food Donation</td>
              </tr>
            ) : null}
              <tr><td colSpan={4}>---------------------------------</td></tr>
            

            <tr><td colSpan={4} align="right"><b>Total Rs. {selectedBillMeta.net_total}</b></td></tr>
               <tr>
              <td colSpan={4} align='right'>==========</td>
            </tr>
            <tr><td colSpan={4} align="center" style={{fontSize : 12}}>Thank you, Come Again.</td></tr>
            <tr><td colSpan={4}>---------------------------------</td></tr>
          </tbody>
        </table>
    );
  };

  const renderPrintableBill = () => {
    if (!selectedBillMeta || selectedBillItems.length === 0) return null;
    return (
      <div style={{ display: 'none' }}>
        {renderBillTable({ withRef: true })}
      </div>
    );
  };

  return (
    <Box p={2} style={{ paddingTop: '100px' }}>
      <div style={{ textAlign: 'left', marginBottom: '20px', fontSize: '30px', fontWeight: 'bold' }}>
        Bill History
      </div>
      <TextField
        label="Search Invoice No"
        variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 2 }}
      />

      <TableContainer component={Paper} sx={{ maxHeight: 600, overflowY: 'auto' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>Invoice No</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Inv Date</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Gross</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Discount</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Net</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Service Chrg</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Cashier</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredBills.map((bill, idx) => (
              <TableRow key={idx}>
                <TableCell>{bill.inv_no}</TableCell>
                <TableCell>{bill.inv_date}</TableCell>
                <TableCell>{bill.gross_total}</TableCell>
                <TableCell>{bill.discount}</TableCell>
                <TableCell>{bill.net_total}</TableCell>
                <TableCell>{bill.Service_chrg}</TableCell>
                <TableCell>{bill.username}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleView(bill.inv_no)}>
                    <VisibilityIcon />
                  </IconButton>
                  {userRole === 1 ? (
                    <IconButton onClick={() => handlePrint(bill.inv_no)}>
                      <PrintIcon />
                    </IconButton>
                  ) : null}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={viewOpen} onClose={() => setViewOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>View Bill</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            {renderBillTable({ withRef: false })}
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button variant="contained" onClick={() => setViewOpen(false)}>Close</Button>
          </Box>
        </DialogContent>
      </Dialog>

      {renderPrintableBill()}
    </Box>
  );
}

export default Billhistory;
